module.exports = __webpack_public_path__ + "static/media/18ECA30.15d8cad4.jpg";